import {Component, computed, inject} from '@angular/core';
import {TitleCasePipe} from '@angular/common';
import {AppStore} from '../../../../../shared/store/app.store';
import {PhoneFormatPipe} from '../../../../../shared/pipes/phone-format';

@Component({
  selector: 'app-compare-print-header',
  imports: [
    TitleCasePipe,
    PhoneFormatPipe
  ],
  templateUrl: './compare-print-header.component.html',
  styleUrl: './compare-print-header.component.css',
})
export class ComparePrintHeaderComponent {
  public appStore = inject(AppStore)

  get date() {
    return new Date().toLocaleDateString();
  }

  vehicle = computed(() => {
    const ro = this.appStore.cart().repair_order;
    if (!ro) return '';

    return [ro.vehicle_year, ro.vehicle_make, ro.vehicle_model]
      .filter(Boolean)
      .join(' ');
  });
}
